import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Ui } from "@silvertours/front-shared";
import { Badge, Heading, ModuleContainer } from "../../element";
import { Tabs } from "./Tabs";
export var TabListContentBlock = function(param) {
    var behavior = param.behavior, _content = param.content, badge = _content.badge, heading = _content.heading, modules = _content.modules, rules = param.rules;
    var ref = rules || {}, _textStyle = ref.textStyle, textStyle = _textStyle === void 0 ? Ui.RichTextStyle.Primary : _textStyle;
    var headingContent = heading ? _object_spread({
        level: heading.level || "h2"
    }, heading) : undefined;
    return /*#__PURE__*/ _jsxs(ModuleContainer, {
        children: [
            /*#__PURE__*/ _jsx(Badge, {
                content: badge,
                rules: {
                    badge: {
                        style: "orange"
                    }
                }
            }),
            /*#__PURE__*/ _jsx(Heading, {
                content: headingContent,
                rules: {
                    textStyle: {
                        style: textStyle
                    }
                }
            }),
            /*#__PURE__*/ _jsx(Tabs, {
                behavior: behavior,
                content: modules,
                rules: rules
            })
        ]
    });
};
